import 'react';
import { IoShareSocialOutline } from '@react-icons/all-files/io5/IoShareSocialOutline';
import { decorateComponent } from '../../../documentComponents/decorateComponent.js';
import { ImageMapShare as ImageMapShare$1 } from './ImageMapShare.js';
import { ImageMapShareInspector } from './ImageMapShare.Inspector.js';
import { jsx } from '@emotion/react';

var ImageMapShare = decorateComponent(ImageMapShare$1, 'block', {
  id: 'imageMapShare',
  label: '이미지 영역 공유하기',
  disabledMove: true,
  allowedParent: ['image'],
  allowedChildren: [],
  disallowedAncestors: ['a', 'coupon', 'tabButton'],
  defaultProps: {
    platform: 'kakaotalk',
    style: {
      top: '25%',
      left: '25%',
      width: '50%',
      height: '50%'
    }
  },
  renderIcon: function renderIcon() {
    return jsx(IoShareSocialOutline, null);
  },
  renderInspector: ImageMapShareInspector
});

export { ImageMapShare as default };
//# sourceMappingURL=index.js.map
